import React from "react";
import PublicLayout from "../components/PublicLayout";

export default function StaticPage({ title = "Coming Soon", description = "" }) {
  return (
    <PublicLayout title={title}>
      <div className="nt-container mt-8">
        <div className="rounded-xl bg-white border border-slate-200 p-6 sm:p-10 text-center shadow-sm">
          <div className="text-6xl mb-3">🚧</div>
          <h2 className="font-display text-2xl sm:text-3xl mb-2">{title}</h2>
          <p className="text-slate-700 leading-relaxed" data-testid="static-desc">
            {description || `The ${title} section is coming soon. Please check back later for updates.`}
          </p>
        </div>
      </div>
    </PublicLayout>
  );
}
